import React, { Dispatch, SetStateAction, useCallback, useMemo, useState } from "react";
import {
    AppointmentTypes, AppointmentDate, ItemAppointment, onSelectDateCallback,
    ModalAppointmentCheckObj, AppointmentSartoria, AppointmentSartoriaOther, Optional,
    typeAppointmentSartoria, ModalMergeObj
} from "../../../Models/Types.ts";
import { parseDate } from "../../../Utils/StringFunctions.ts";
import ModalAppointmentCheck from "./ModalAppointmentCheck.tsx";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { OutlinedInput } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import ModalAppointmentMerge from "./ModalAppointmentMerge.tsx";
import { RemoteAPI } from "../../../appointmentApi.tsx";
import Loader from "../../UI/Loader.tsx";
import { TileSelectedAppointment } from "../CheckCode.tsx";
import { CopyObject } from "../../../Utils/ObjectsFunctions.ts";

const emptyModalAppointmentObj = { show: false, customerQuantity: 0, selectedType: 0 }

export enum TileAppointmentCheckDataLocation {
    INSTANCES,
    OTHER
}

interface TileAppointmentCheckProps {
    id: string,
    dataAppointment: AppointmentSartoria,
    selectedAppointmentDate: AppointmentDate | undefined,
    setAppointmentDate: (key: string, appointemnt: AppointmentDate | null, data: AppointmentSartoria) => void,
    setOthersAppointment: Dispatch<SetStateAction<Array<AppointmentSartoria>>>,
    othersAppointment: Array<AppointmentSartoriaOther>,
    othersAppointmentIndex: number
}


const TileAppointmentCheckOthers: React.FC<TileAppointmentCheckProps> = ({ id, dataAppointment, selectedAppointmentDate, setAppointmentDate, setOthersAppointment, othersAppointment, othersAppointmentIndex }) => {

    const [modalAppointment, setModalAppointment] = useState<boolean>(false)

    const [showModalMerge, setShowModalMerge] = useState<ModalMergeObj>({ show: false, item: null })

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const onSelectDate = useCallback(async (selectedDate: AppointmentDate | null) => {
        setAppointmentDate(id, selectedDate, dataAppointment);
        setIsLoading(false)
        setModalAppointment(false)
    }, [])

    const onClickDivide = useCallback((item: ItemAppointment) => {
        setOthersAppointment(old => {
            let data = CopyObject(old) as Array<AppointmentSartoria>;

            data[othersAppointmentIndex].items = data[othersAppointmentIndex].items.filter(itemFilter => itemFilter.id !== item.id);
            data[othersAppointmentIndex].men = data[othersAppointmentIndex].items.reduce((sum, item) => item.tipo === AppointmentTypes.MAN ? sum += 1 : sum += 0, 0)
            data[othersAppointmentIndex].women = data[othersAppointmentIndex].items.reduce((sum, item) => item.tipo === AppointmentTypes.WOMAN ? sum += 1 : sum += 0, 0)

            data = [...data, {
                appointmentType: AppointmentTypes.RETRY_OTHERS,
                items: [CopyObject(item)],
                men: item.tipo === AppointmentTypes.MAN ? 1 : 0,
                women: item.tipo === AppointmentTypes.WOMAN ? 1 : 0,
            }
            ];

            return data;
        })
    }, [othersAppointmentIndex])

    const onMergeAppointment = useCallback((arriveIndex: number) => {
        setOthersAppointment(old => {
            let data = CopyObject(old) as Array<AppointmentSartoria>;

            const item = data[othersAppointmentIndex].items[0];
            data[arriveIndex].items.push(CopyObject(item))
            data[arriveIndex].men = data[arriveIndex].items.reduce((sum, item) => item.tipo === AppointmentTypes.MAN ? sum += 1 : sum += 0, 0)
            data[arriveIndex].women = data[arriveIndex].items.reduce((sum, item) => item.tipo === AppointmentTypes.WOMAN ? sum += 1 : sum += 0, 0)

            data = data.filter((d, index) => index !== othersAppointmentIndex);

            return data;
        })
    }, [othersAppointmentIndex])

    const buttonDivide = useCallback((item: ItemAppointment) => {

        if (othersAppointment[othersAppointmentIndex].items.length > 1) {
            return <button className="button-divide" onClick={() => { onClickDivide(item) }}>  Prendi appuntamento singolo <img className="icon-temptation" src="/calendario-appuntamenti/icons/people-arrows-separate.svg" /></button>
        } else if (othersAppointment.length > 1) {
            return <button className="button-divide" onClick={() => setShowModalMerge({ show: true, item: item })}>  Unisci ad altro appuntamento <img className="icon-temptation" src="/calendario-appuntamenti/icons/people-arrows-union.svg" /></button>
        }

    }, [othersAppointment])

    const handleClosingAppointmentMerge = useCallback(() => {
        setShowModalMerge({ show: false, item: null })
    }, [])

    const stateContainer = useCallback((item: ItemAppointment) => {
        console.log(item)
        let stateReturn = <></>
        if (item.stato.toLowerCase() === "Prendere le Misure".toLowerCase()) {
            stateReturn = <div className="container-state-appointment-icon"> Per <div className="state-appointment"> <i className="fa-solid fa-ruler"></i> {item.stato} </div></div>
        } else if (item.stato.toLowerCase() === "Prova".toLowerCase()) {
            stateReturn = <div className="container-state-appointment-icon">Per la <div className="state-appointment"> <i className="fa-solid fa-box-heart"></i>  {item.stato} </div></div>
        } else if (item.stato.toLowerCase() === "Prova con consegna".toLowerCase()) {
            if (AppointmentTypes.toString(item.tipo) === "Uomo" || AppointmentTypes.toString(item.tipo) === "Sposo") {
                stateReturn = <div className="container-state-appointment-icon">  Per la <div className="state-appointment"> <i className="fa-solid fa-person"></i> {item.stato} </div></div>
            } else {
                stateReturn = <div className="container-state-appointment-icon">Per la <div className="state-appointment"> <i className="fa-solid fa-person-dress"></i> {item.stato} </div></div>
            }
        }

        return stateReturn;

    }, [dataAppointment])

    return <>
        {isLoading && <div className="loader-overlap-container"><Loader /></div>}
        <div className="container-tile-appointment-retire">
            {dataAppointment.items.map((item, index) => <div style={index > 0 ? { borderTop: "1px solid #a9a9a942", paddingTop: "15px" } : {}} key={`container-tile-appointment-retire-item-${index}`} className="tile-appointment-retire">
                <div style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    <div className="container-button-divide">
                        {buttonDivide(item)}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {stateContainer(item)}
                    </div>
                </div>

                <div className="appointment-name-container">dell'abito da <div /* className={"type-appointment-container " + ` type-${item.tipo}`} */>  {AppointmentTypes.toString(item.tipo)}</div> {item.nome !== "" ? `di  ${item.nome}` : ""} </div>
                <div>Contr. {item.nr_contratto} </div>
            </div>)}
            <div className={`container-button-appointment show-flex`}>
                <button id="button-date-appointment" className="button-date-appointment" onClick={() => setModalAppointment(true)}>
                    {selectedAppointmentDate === null || selectedAppointmentDate === undefined ?
                        <>
                            Seleziona data
                            <img
                                className="image-calendar" src="/calendario-appuntamenti/images/calendar-clock-icon_34472.webp" />
                        </>
                        :
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "2vw"
                            }}
                        >
                            <div>
                                <div>Appuntamento {AppointmentTypes.toString(dataAppointment.appointmentType)}</div>
                                <div>{parseDate(selectedAppointmentDate.date)}</div>
                                <div>{selectedAppointmentDate.slots[0].start}</div>
                            </div>
                            <img className='icon-modify' src='./Assets/pen_edit_icon_177296.webp' />
                        </div>
                    }
                </button>
            </div>
        </div>
        {modalAppointment && <ModalAppointmentCheck
            manNumber={dataAppointment.men}
            womanNumber={dataAppointment.women}
            customersQuantity={dataAppointment.women + dataAppointment.men}
            onSelectDate={onSelectDate}
            selectedType={dataAppointment.appointmentType}
            setVisibleModal={setModalAppointment}
        />}

        {showModalMerge.show && <ModalAppointmentMerge ownerIndex={othersAppointmentIndex} onMergeAppointment={onMergeAppointment} appointmentToMerge={othersAppointment} handleClosingAppointmentMerge={handleClosingAppointmentMerge} />}
    </>
}

export default TileAppointmentCheckOthers